import { FC } from 'react';

import { $user } from 'state/stores/user';
import ReferralCodeCardView from './ReferralCodeCard.view';

const ReferralCodeCardContainer: FC = () => {
  const user = $user.selectors.useUser();

  // Get referral code from user, or generate one from user ID if not available
  const referralCode =
    user?.referralCode || user?._id?.slice(-6).toUpperCase() || '';
  const totalReferredUsers = user?.referralCount || 0;

  if (!referralCode) {
    return null;
  }

  return (
    <ReferralCodeCardView
      referralCode={referralCode}
      totalReferredUsers={totalReferredUsers}
    />
  );
};

export default ReferralCodeCardContainer;
